<template>

    <a :class="`style_confirmAttendanceButton ${classDiv_val}`"
       title="Confirm Booking"
        :style="optionalCustomStyle"
       @click.stop="modal_open_event"
    >
        {{ title_val}} {{ dateConfirm }}
    </a>


</template>

<script>

/**   ??? this component load on different pages with different style **/
import {EventBus} from "@/events/event-bus";
import moment from "moment/moment";

export default {
    name: "confirmAttendanceButton",
    props: {
        buttonConfirmStatus :null,
        elementId:null,
        classDiv:null,
        title:null,
        optionalVisitId:null,
        bookingId: null,
        infoForConfirmation: null,
        dateConfirm: null,
        optionalCustomStyle: null,
        visitsExisted: null,
      parentFunction: Function

    },
    data() {
        return {
            visit_status_val:'',
            title_val:this.title,
            classDiv_val:this.classDiv,
            all_selected_visit:[],
            reminder_data: [],

        }
    },

    methods : {

         modal_open_event(){
              if (this.title_val == 'Started' || this.title_val == 'Finished' || this.title_val == 'Arrived' ||this.title_val == 'On the way'){
                this.$emit('child-event-toggleCollapse');
                return
             }
             EventBus.$emit('infoForConfirmation', this.infoForConfirmation);
             var data_section = $('#'+this.elementId);
           $(data_section).modal('show')

         }
         },

     mounted() {

        var vm=this;
        this.$nextTick(function(){
        EventBus.$on('titleConfirmationChange', record => {
                if ( record.user_type != "customer"   && record && vm.optionalVisitId
                 && (  parseInt(record.visit_id  )  ==  parseInt (vm.optionalVisitId ) || parseInt(record.multiple_day_id  )  ==  parseInt (vm.optionalVisitId ) ) )  {
                if (record.checkout_date ) {
                   vm.title_val = 'Finished'
                   vm.classDiv_val=   vm.classDiv_val+" confirm-color"
                }
                else if (record.checkin_date) {
                   vm.title_val = 'Started'
                   vm.classDiv_val= vm.classDiv_val+" btn-info-custom-class" ;
                }
                else if (record.arrived_time) {
                    vm.title_val= 'Arrived'
                    vm.classDiv_val= vm.classDiv_val+" btn-info-custom-class" ;
                }
                else if (record.on_the_way_time) {
                   vm.title_val = 'On the way'
                 vm.classDiv_val= vm.classDiv_val+" btn-info-custom-class" ;
                }

                else if (  record.Confirm_attendance_status_btn_title && record.Confirm_attendance_status_btn_title.replace(/\s+/g, '')  == 'Confirmed') {
                    vm.title_val = 'Confirmed'
                    vm.classDiv_val= vm.classDiv_val+" confirm-color" ;
                }
                else if (  record.Confirm_attendance_status_btn_title && record.Confirm_attendance_status_btn_title.replace(/\s+/g, '')  == 'Unconfirmed') {
                   // vm.title_val = 'Confirm'
                    vm.title_val = 'Unconfirmed'
                    vm.classDiv_val=vm.classDiv_val.replace(' confirm-color','');
                    vm.classDiv_val= vm.classDiv_val+" unconfirm-color" ;
                }

                }

        });
        })

     }
    ,

}
</script>
<style scoped>
.style_confirmAttendanceButton{
    margin-left:2px;
    margin-bottom: 0px;
    text-decoration: none;
    font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 13px;
}

.confirm-color{
    background-color: #37BD5D !important;
    color:#FFFFFF!important;
    border-radius: 100px!important;
    padding: 4px 12px 6px 12px!important;
    width: auto!important;
}
.btn-info-custom-class{
    background-color: #03A9F4 !important;
    color:#FFFFFF!important;
    border-radius: 100px!important;
    padding: 4px 12px 6px 12px!important;
    width: auto!important;
}
</style>